import React, { useState } from 'react'
import Data from '../types/Data'

export default ({ choices, onChoice }: { choices: Array<Data>, onChoice: (event: string) => void } ) => {
	const [ hover, setHover ] = useState<{
		x: number,
		y: number,
		width: number,
		height: number,
		done: boolean,
	}>({
		x: 0,
		y: 0,
		width: 0,
		height: 0,
		done: false,
	})

	return (
		<div className={"modal" + (hover.done ? ' modal-finish' : '')}>
			<div
				className={"choices" + (hover.done ? ' finish' : '')}
				onMouseLeave={() => {
					if (!hover.done) {
						setHover({ ...hover, height: 0 })
					}
				}}
			>
				<div className={'hover' + (hover.done ? ' done' : '')} style={{ transform: `translate(${hover.x}px, ${hover.y}px)`, width: `${hover.width}px`, height: `${hover.height}px` }} />
				{choices.map(q => (
					<div
						className="choice"
						key={q.text}
						onMouseEnter={(e) => {
							if (!hover.done) {
								const target = e.target as HTMLElement
								setHover({
									x: target.offsetLeft,
									y: target.offsetTop,
									width: target.offsetWidth,
									height: target.offsetHeight,
									done: false,
								})
							}
						}}
						onClick={() => {
							setHover({ ...hover, done: true })
							setTimeout(() => {
								onChoice(q.text)
							}, 800)
						}}
					>{q.text}</div>
				))}
			</div>
			<div className="reticle">
				<div className="double" />
			</div>
		</div>
	)
}
